// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonAdd_root__2Fjxk"};